import { useEffect } from 'react';
import { api, ApiError } from '../lib/api';
import { useAuthStore } from '../stores/authStore';

// Au mount du root App, appelle GET /api/auth/me pour restaurer la session
// si le cookie est valide. Définit isBootstrapped à true dans tous les cas.
export function useBootstrapAuth(): void {
  const setUser = useAuthStore((s) => s.setUser);
  const setBootstrapped = useAuthStore((s) => s.setBootstrapped);

  useEffect(() => {
    let cancelled = false;
    api.auth
      .me()
      .then(({ user }) => {
        if (!cancelled) setUser(user);
      })
      .catch((err: unknown) => {
        if (err instanceof ApiError && err.status === 401) {
          // pas authentifié, normal
        } else if (!cancelled) {
          console.error('Erreur bootstrap auth:', err);
        }
      })
      .finally(() => {
        if (!cancelled) setBootstrapped();
      });
    return (): void => {
      cancelled = true;
    };
  }, [setUser, setBootstrapped]);
}
